import Comment from '../elements/comment';

const starWidth = 15;
const starSpacing = 3;

function StarRating(props) {
    var whole, decimal, percentageRating, starRatingStyle;

    whole = Math.floor(props.rating);
    decimal = props.rating - whole;
    percentageRating = Math.min(87, whole * starWidth + whole * starSpacing + decimal * starWidth);
    starRatingStyle = {
        width: percentageRating + 'px'
    };

    return (
        <div className={['rnr-stars'].concat(props.additionalClassNames || []).join(' ')}>
            <div className="rnr-stars__container">
                <svg className="rnr__star" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
            </div>
            <div className="rnr-stars__container rnr-stars__rating" style={starRatingStyle}>
                <svg className="rnr__star rnr__star--filled" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star rnr__star--filled" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star rnr__star--filled" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star rnr__star--filled" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
                <Comment />
                <svg className="rnr__star rnr__star--filled" viewBox="0 0 20 20">
                    <polygon points="10,0 4,20 20,7 0,7 16,20" />
                </svg>
            </div>
        </div>
    );
}

export default StarRating;